// src/models/ReceptorEjercicio.js

export default class ReceptorEjercicio {
  constructor(data) {
    this.noPreguntas = data["04 NO_PREGUNTAS"] || 0;
    this.random = data["05 RANDOM"] || false;
    this.tiempos = data["06 TIEMPO"] || [];
    this.categorias = data["08 CATEGORIA"] || [];
    this.preguntas = data["09 PREGUNTA"] || [];
    this.respuestasCorrectas = data["10 RESPUESTA"] || [];
    this.opciones = data["11 OPCION"] || [];
    this.soluciones = data["12 SOLUCION"] || [];       // 👈 justificación textual
    this.imagenesPreguntas = data["14 IMAGEN2"] || []; // 👈 imágenes junto a las preguntas
    this.cacheOpciones = {};
  }

  // Tipo de pregunta según categoría
  tipoPregunta(index) {
    const categoria = this.categorias[index];
    switch (categoria) {
      case "1": return "Opción múltiple";
      case "2": return "Verdadero/Falso";
      case "3": return "Abierta";
      case "4": return "Examen final";
      case "5": return "Pregunta con imágenes";
      default: return "Desconocida";
    }
  }

  // Opciones mezcladas con la respuesta correcta
  opcionesConRespuesta(index) {
    if (this.cacheOpciones && this.cacheOpciones[index]) {
      return this.cacheOpciones[index];
    }

    const correcta = this.respuestasCorrectas[index];
    const distractores = this.opciones.slice(index * 3, index * 3 + 3);
    const todas = [correcta, ...distractores];
    const resultado = this.random ? this.shuffle(todas) : todas;

    if (!this.cacheOpciones) this.cacheOpciones = {};
    this.cacheOpciones[index] = resultado;
    return resultado;
  }

  // Justificación de la respuesta (solo texto)
  justificacion(index) {
    return this.soluciones[index] || null;
  }

  // Imagen asociada a la pregunta
  imagenPregunta(index) {
    const recurso = this.imagenesPreguntas[index] || null;
    return recurso === "0" ? null : recurso;
  }

  // Mezclar arrays (para randomizar opciones)
  shuffle(array) {
    const copia = [...array];
    for (let i = copia.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [copia[i], copia[j]] = [copia[j], copia[i]];
    }
    return copia;
  }
}
